import {
  resourceReducer,
} from 'redux-resource';
import {
  includedResources,
} from 'redux-resource-plugins';

import {
  allListPlugin,
  customListPlugin,
} from './plugins';

export default resourceReducer('personalExercises', {
  plugins: [
    allListPlugin,
    customListPlugin,
    includedResources,
  ],
});
